const DEFAULT_LOCALE = 'en_US';
const NO_OP_FN = () => {};
const PRIMARY_BTN_BG_COLOR_PROP = 'web.global.button.primary.bgColor.start';
export default {};
export { DEFAULT_LOCALE, NO_OP_FN, PRIMARY_BTN_BG_COLOR_PROP };
